import { CalendarViewTypes } from '../types';

const VIEW_NAMES: CalendarViewTypes[] = [
	'day',
	'week',
	'month',
	'year',
	'agenda',
];

export const getCalendarViewPath = (pathname: string, view: string): string => {
	const segments = pathname.split('/').filter(Boolean);
	while (
		segments.length > 0 &&
		VIEW_NAMES.includes(segments[segments.length - 1] as CalendarViewTypes)
	) {
		segments.pop();
	}
	return `/${segments.join('/')}/${view}`;
};
